import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const CapabilitiesPage = lazy(() => import('../pages/capabilities/page'));
const UseCasesPage = lazy(() => import('../pages/use-cases/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Solution pages
const MachineLearningPage = lazy(() => import('../pages/solutions/machine-learning/page'));
const AIAutomationPage = lazy(() => import('../pages/solutions/ai-automation/page'));
const DataIntelligencePage = lazy(() => import('../pages/solutions/data-intelligence/page'));
const CustomDevelopmentPage = lazy(() => import('../pages/solutions/custom-development/page'));
const AIIntegrationPage = lazy(() => import('../pages/solutions/ai-integration/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/capabilities',
    element: <CapabilitiesPage />,
  },
  {
    path: '/use-cases',
    element: <UseCasesPage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/solutions/machine-learning',
    element: <MachineLearningPage />,
  },
  {
    path: '/solutions/ai-automation',
    element: <AIAutomationPage />,
  },
  {
    path: '/solutions/data-intelligence',
    element: <DataIntelligencePage />,
  },
  {
    path: '/solutions/custom-development',
    element: <CustomDevelopmentPage />,
  },
  {
    path: '/solutions/ai-integration',
    element: <AIIntegrationPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
